'use client';

import * as React from 'react';
import { Input as BaseInput } from '@base-ui/react/input';
import { cn } from '@/lib/utils/cn';

type InputProps = Omit<React.ComponentPropsWithoutRef<typeof BaseInput>, 'className'> & {
  defaultValue?: string | number;
  value?: string | number;
  className?: string;
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return (
    <BaseInput
      ref={ref}
      type={type}
      className={cn(
        // Base radius is rounded-sm (6px) per the design token scale's
        // "buttons, inputs, badges, chips" line — rounded-control (10.5px)
        // was too round for form fields and made admin settings look
        // oversized. Callers can still override per-instance via className.
        'flex h-11 w-full rounded-sm border border-zen-input bg-transparent px-3 py-2 text-base text-zen-text transition-colors placeholder:text-zen-text-subtle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zen-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className,
      )}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
